export default __webpack_public_path__ + "static/media/how-it-work3-blue.b06a88bb.svg";